var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._l((_vm.schema),function(sc,index){return [_c('t-widget',{key:index,attrs:{"schema":sc,"data":_vm.data,"context":_vm.context},on:{"input":_vm.simpleEmit}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }